export default __webpack_public_path__ + "static/media/headerImage2.41a7bafb.png";